{
	"aperture": "Aperture",
	"capturedAt": "Captured at {{date}}",
	"fNumber": "f / {{value}}",
	"focalLength": "Focal length",
	"iso": "ISO",
	"mb": "MB",
	"mm": "{{value}} mm",
	"panelInfo": "Info",
	"shutterSpeed": "Shutter speed",
	"shutterSpeedValue": "1/{{speed}} sec",
	"unknownCamera": "Unknown Camera"
}
